import type { ComponentType, ReactNode } from "react"
import { Outlet } from "react-router"

type TopBarLayoutProps = {
  children?: ReactNode
  TopBarComponent: ComponentType
}

export default function TopBarLayout({ children, TopBarComponent }: TopBarLayoutProps) {
  return (
    <div className="flex h-full min-w-0 flex-1 flex-col overflow-hidden">
      <TopBarComponent />
      <main className="min-h-0 flex-1 overflow-auto">{children ? children : <Outlet />}</main>
    </div>
  )
}
